import script from "./esCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./esCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./esCalendar.vue?vue&type=style&index=0&id=39d0b738&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39d0b738"]])

export default __exports__